import { tv } from "tailwind-variants";
import { focusRing } from "./utils";

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** @default 'primary' */
  variant?: "primary" | "secondary" | "success" | "warning" | "error";
  /** @default 'default' */
  size?: "sm" | "default" | "lg";
  children: React.ReactNode;
}

const badge = tv({
  extend: focusRing,
  base: "flex w-fit items-center rounded-lg font-bold inline-flex whitespace-nowrap",
  variants: {
    variant: {
      primary: "bg-blue-600 text-white",
      secondary: "bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-gray-200",
      success: "bg-green-600 text-white",
      warning: "bg-yellow-500 text-white",
      error: "bg-red-600 text-white"
    },
    size: {
      sm: "h-6 text-xs px-1.5 py-0.5",
      default: "h-7 text-sm px-2 py-1 sm:h-8 sm:px-3.5 sm:py-2",
      lg: "h-9 px-4 py-2 text-base"
    }
  },
  defaultVariants: {
    variant: "primary",
    size: "default"
  }
});

export function Badge({ variant, size, children, className, ...props }: BadgeProps) {
  return (
    <span {...props} className={badge({ variant, size, className })}>
      {children}
    </span>
  );
}
